"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Enterprise;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
    Enterprise
    ---
    All enterprise related data
*/
var Enterprise = (_Enterprise = {
  enterprise: {
    nl: 'Onderneming',
    fr: 'Entreprise',
    en: 'Enterprise'
  },
  name_translations: {
    nl: 'Naam',
    fr: 'Nom',
    en: 'Name'
  },
  description_translations: {
    nl: 'Beschrijving',
    fr: 'Déscription',
    en: 'Description'
  },
  entrepreneur_info: {
    nl: 'Ondernemingsgegevens',
    fr: "Information d'entrepreneur",
    en: 'Entrepreneur Information'
  },
  enterprises: {
    nl: 'Ondernemingen',
    fr: 'Entreprises',
    en: 'Enterprises'
  },
  all_enterprises: {
    nl: 'Alle ondernemingen',
    fr: 'Toutes les entreprises',
    en: 'All enterprises'
  },
  total_enterprises: {
    nl: 'Totaal ondernemingen',
    fr: 'Total entreprises',
    en: 'Total enterprises'
  },
  establishment: {
    nl: 'Vestiging',
    fr: 'Établissement',
    en: 'Establishment'
  },
  establishment_info: {
    nl: 'Vestigingsgegevens',
    fr: "Informations sur l'établissement",
    en: 'Establishment info'
  },
  establishments: {
    nl: 'Vestigingen',
    fr: 'Établissements',
    en: 'Establishments'
  },
  establishment_name: {
    nl: 'Vestigginsnaam',
    fr: "Nom de l'établissement",
    en: 'Establishment name'
  },
  establishment_trade_name: {
    nl: 'Handelsnaam van vestiging',
    fr: "Nom commercial de l'établissement",
    en: 'Trade name of establishment'
  },
  number_of_establishment: {
    nl: 'Nummer vestigingseenheid',
    fr: "Numéro d'établissement",
    en: 'Number of the establishment'
  },
  id_cbe: {
    nl: 'ID KBO',
    fr: 'ID BCE',
    en: 'ID CBE'
  },
  enterprise_name: {
    nl: 'Naam onderneming',
    fr: "Nom d'entreprise",
    en: 'Enterprise name'
  },
  enterprise_type: {
    nl: 'Type onderneming',
    fr: 'Type d\'entreprise',
    en: 'Enterprise type'
  },
  identity: {
    nl: 'Identiteit',
    fr: 'Identité',
    en: 'Identity'
  },
  group_name: {
    nl: 'Groepsnaam',
    fr: 'Nom du groupe',
    en: 'Group name'
  },
  trade_name: {
    nl: 'Handelsnaam',
    fr: 'Nom commercial',
    en: 'Trade name'
  },
  juridical_form: {
    nl: 'Juridische vorm',
    fr: 'Forme juridique',
    en: 'Juridical form'
  },
  commercial_transaction: {
    nl: 'Commerciële transactie',
    fr: 'Transaction commerciale',
    en: 'Commercial transaction'
  },
  vat_number: {
    nl: 'BTW-nummer',
    fr: 'Numéro de TVA',
    en: 'VAT number'
  },
  abbreviation: {
    nl: 'Afkorting',
    fr: 'Abréviation',
    en: 'Abbreviation'
  },
  legal_info: {
    nl: 'Legale info',
    fr: 'Informations légales',
    en: 'Legal info'
  },
  legal_situation: {
    nl: 'Rechtstoestand',
    fr: 'Situation juridique',
    en: 'Legal situation'
  },
  external_identification: {
    nl: 'Externe identificatie',
    fr: 'Identification externe',
    en: 'External identification'
  },
  establishment_number: {
    nl: 'Vestigingsnummer',
    fr: "Numéro d'établissement",
    en: 'Establishment number'
  }
}, _defineProperty(_Enterprise, "establishment_name", {
  nl: 'Vestigingsnaam',
  fr: "Nom d'établissement",
  en: 'Establishment name'
}), _defineProperty(_Enterprise, "agreement", {
  nl: 'Overeenkomst',
  fr: 'Accord',
  en: 'Agreement'
}), _defineProperty(_Enterprise, "new_agreement", {
  nl: 'Nieuwe overeenkomst',
  fr: 'Nouvel accord',
  en: 'New agreement'
}), _defineProperty(_Enterprise, "order_form", {
  nl: 'Bestelbon',
  fr: 'Bon de commande',
  en: 'Order form'
}), _defineProperty(_Enterprise, "new_order_form", {
  nl: 'Nieuwe bestelbon',
  fr: 'Nouveau bon de commande',
  en: 'New order form'
}), _defineProperty(_Enterprise, "registration", {
  nl: 'Registratie',
  fr: 'Registration',
  en: 'enregistrement'
}), _defineProperty(_Enterprise, "registration_number", {
  nl: 'Registratie nummer',
  fr: 'Registration number',
  en: "Numéro d'enregistrement"
}), _defineProperty(_Enterprise, "legal_form", {
  nl: 'Rechtsvorm',
  fr: 'Forme légale',
  en: 'Legal form'
}), _defineProperty(_Enterprise, "status", {
  nl: 'Status',
  fr: 'Statut',
  en: 'Status'
}), _defineProperty(_Enterprise, "external_identification", {
  nl: 'Externe identificatie',
  fr: 'Identification externe',
  en: 'External identification'
}), _defineProperty(_Enterprise, "categories", {
  nl: 'Categorieën',
  fr: 'Catégories',
  en: 'Categories'
}), _defineProperty(_Enterprise, "category", {
  nl: 'Categorie',
  fr: 'Catégorie',
  en: 'Category'
}), _defineProperty(_Enterprise, "rubrics", {
  nl: 'Rubrieken',
  fr: 'Rubriques',
  en: 'Rubrics'
}), _defineProperty(_Enterprise, "nacebel", {
  nl: 'Nacebel',
  fr: 'Nacebel',
  en: 'Nacebel'
}), _defineProperty(_Enterprise, "magazines", {
  nl: 'Magazines',
  fr: 'Magazines',
  en: 'Magazines'
}), _defineProperty(_Enterprise, "promos", {
  nl: "Promo's",
  fr: 'Promos',
  en: 'Promos'
}), _defineProperty(_Enterprise, "price_per_click", {
  nl: "Prijs per klik",
  fr: 'prix par clic',
  en: 'Price per click'
}), _defineProperty(_Enterprise, "price_per_hour", {
  nl: "Prijs per uur",
  fr: 'prix par heur',
  en: 'Price per hour'
}), _defineProperty(_Enterprise, "price_per_keyword", {
  nl: "Prijs per keyword",
  fr: 'prix par keyword',
  en: 'Price per keyword'
}), _Enterprise);
var _default = Enterprise;
exports["default"] = _default;